import React from "react";

const Spinner = (message = "Beep bop, computing logic.") => {
  return <div>{message}</div>;
};

export default Spinner;
